import axios from './index';

class IfscApi {
  static Get = (data) => {
    // console.log(data);
    return axios.get(`${base}/${data.ifsc}`);
  };
}

let base = 'comm/ifsc';

export default IfscApi;
